/* eslint-disable */
export const setCookie =  (name, value, options) => {
    options = options || {};

    var hostName = window.location.host.split(':')[0];

    var host = hostName.split('.').reverse().slice(0, 2);

    options.domain = `.${host.reverse().join('.')}`;

    var expires = options.expires;

    if (typeof expires == "number" && expires) {
      var d = new Date();
      d.setTime(d.getTime() + expires * 1000);
      expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
      updatedCookie += "; " + propName;
      var propValue = options[propName];
      if (propValue !== true) {
        updatedCookie += "=" + propValue;
      }
    }

    document.cookie = updatedCookie;
  }
